import {Fragment, useEffect, useState} from "react";
import WelcomeToSession from "../Home/components/WelcomeToSession";
import OurServiceAPI from  '~/api/ourServiceApi';
import AOS from "aos";
import Skeleton from "react-loading-skeleton";
import "aos/dist/aos.css";
function OurService(){
    const [ourService, setOurService] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        OurServiceAPI.getAll()
            .then((res) => {
                setOurService(res.data);
                setLoading(false);
            })
            .catch((err) => {
            });
        AOS.init({
            duration: 1000,
            easing: "ease-in-out",
            once: true,
            mirror: false
        });
    }, []);
    return (
        <Fragment>
            <WelcomeToSession screen="Our Service"/>
            <div className="container-small">
                <p className="mb-2">
                    Welcome to the Platonic and Socratic approach to knowledge and wisdom. This AI chatbot is an intellectual and spiritual buffet, and you're in for the treat of a lifetime.
                </p>
                <p className="mb-2">
                    BreakThrough understands the frustration of having unanswered questions. Our dedication to helping you make informed decisions sets us apart. We analyze your inquiry by asking relevant, thought-provoking questions and providing you with insightful, comprehensive responses.
                </p>
                <p className="mb-2">
                    Our approach fosters independent and critical thinking, ensuring you receive the best answers to life's most pressing questions.
                </p>
            </div>
            <section>
                <div className="container-medium">
                    {
                        loading && (
                            <div>
                                <Skeleton height={10} count={5} containerClassName={"w-100"}/>
                            </div>
                        )
                    }
                    {
                        !loading && (
                            <div className="row gy-7">
                                {
                                    ourService.map((item, index) => (
                                        <div key={index} className="col-lg-4 col-md-6 service-item d-flex aos-init aos-animate" data-aos="fade-up" data-aos-delay={(index + 1)*100}>
                                            <div className="icon flex-shrink-0 me-5 fs-5 text-danger"
                                                 dangerouslySetInnerHTML={{__html: item.Icon}}/>
                                            <div>
                                                <h4 className="text-primary">{item.Title}</h4>
                                                <p className="fs-8-1">{item.Description}</p>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        )
                    }
                </div>
            </section>
        </Fragment>
    )
}

export default OurService;
